var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 183.67,
    height: 122.243,
    viewBox: "0 0 183.67 122.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(350.907 -1329.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M888.886,349.9l-.069,4.3-125.483-2a36.235,36.235,0,0,0-36.34,30.271,26.874,26.874,0,0,1-21.772-26.73,26.791,26.791,0,0,1,27.211-26.359L871.148,331.6A18.038,18.038,0,0,1,888.886,349.9",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M888.669,363.683,888.26,389.5,787.146,387.9a36.337,36.337,0,0,0-35.1,25.122,26.956,26.956,0,0,1-16.076-24.976l.008-.237a26.772,26.772,0,0,1,27.2-26.127Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M887.92,398.976a58.393,58.393,0,0,1-58.968,52.646l-42.2-.672a27.775,27.775,0,0,1-19.5-8.556,26.3,26.3,0,0,1-7.46-18.98,25.415,25.415,0,0,1,.332-3.514,26.785,26.785,0,0,1,26.872-22.524Z",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup20);
export default __webpack_public_path__ + "static/media/Group 20.c435831c090ee6778e5836fe80af1f18.svg";
export { ForwardRef as ReactComponent };